/** Score dial: an SVG ring (attributes only, no inline styles) with the score in the middle. */
export function ScoreRing({ score, max }: { score: number; max: number }) {
  const r = 52;
  const c = 2 * Math.PI * r;
  const frac = max > 0 ? Math.min(1, Math.max(0, score / max)) : 0;
  return (
    <div className="relative mx-auto size-40" aria-hidden>
      <svg viewBox="0 0 120 120" className="size-40 -rotate-90">
        <defs>
          <linearGradient id="ring-amber" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" className="[stop-color:var(--brand-heading-from)]" />
            <stop offset="55%" className="[stop-color:var(--brand-heading-mid)]" />
            <stop offset="100%" className="[stop-color:var(--brand-heading-to)]" />
          </linearGradient>
        </defs>
        <circle cx="60" cy="60" r={r} fill="none" className="stroke-border" strokeWidth="10" />
        <circle
          cx="60"
          cy="60"
          r={r}
          fill="none"
          stroke="url(#ring-amber)"
          strokeWidth="10"
          strokeLinecap="round"
          strokeDasharray={`${String(c * frac)} ${String(c)}`}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-display text-4xl font-bold tabular-nums">{score}</span>
        <span className="text-xs text-muted-foreground">/ {max}</span>
      </div>
    </div>
  );
}

/** Thin section score bar (SVG width attribute: CSP-safe). */
export function Bar({ value, max }: { value: number; max: number }) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <svg viewBox="0 0 100 6" preserveAspectRatio="none" className="h-1.5 w-full" aria-hidden>
      <rect width="100" height="6" rx="3" className="fill-border" />
      <rect width={pct} height="6" rx="3" fill="url(#ring-amber)" />
    </svg>
  );
}
